import React from 'react';
import UnderConstructionPage from '../UnderConstructionPage';

export default function DataIntegrity() {
  return (
    <UnderConstructionPage
      title="Admin • Data Integrity"
      description="Phase 2: Deceased dates + mismatched emails/addresses."
    />
  );
}
